<template><span class="lu-spinner-wrap" role="status"><span class="lu-spinner" aria-hidden="true"></span><span class="lu-sr-only">{{ label || $t('ui.loading') }}</span></span></template>
<script>export default { name: 'UiSpinner', props: { label: { type: String, default: '' } } };</script>
